function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 8.5,23.5H1c-0.276,0-0.5-0.224-0.5-0.5v-9c0-0.276,0.224-0.5,0.5-0.5h6.5 ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 16.5,13.5H23 c0.276,0,0.5,0.224,0.5,0.5v9c0,0.276-0.224,0.5-0.5,0.5h-7.5 ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 19,15.5h2c0.276,0,0.5,0.224,0.5,0.5v1c0,0.276-0.224,0.5-0.5,0.5 h-2c-0.276,0-0.5-0.224-0.5-0.5v-1C18.5,15.724,18.724,15.5,19,15.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 21.5,21.5h-3V20c0-0.276,0.224-0.5,0.5-0.5h2 c0.276,0,0.5,0.224,0.5,0.5V21.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 3,15.5h2c0.276,0,0.5,0.224,0.5,0.5v1c0,0.276-0.224,0.5-0.5,0.5H3c-0.276,0-0.5-0.224-0.5-0.5 v-1C2.5,15.724,2.724,15.5,3,15.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 3,19.5h2c0.276,0,0.5,0.224,0.5,0.5v1c0,0.276-0.224,0.5-0.5,0.5H3c-0.276,0-0.5-0.224-0.5-0.5 v-1C2.5,19.724,2.724,19.5,3,19.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 13.5,19c0-0.828-0.672-1.5-1.5-1.5s-1.5,0.672-1.5,1.5v4.5h3V19z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 11.5,6.528V3.5 ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 11.5,0.5h4 C15.776,0.5,16,0.724,16,1v2c0,0.276-0.224,0.5-0.5,0.5h-4l0,0V0.5L11.5,0.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 12,9.5c0.828,0,1.5,0.672,1.5,1.5 s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S11.172,9.5,12,9.5z ",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "to-stroke",
  d: "M 16.5,11c0-2.485-2.015-4.5-4.5-4.5S7.5,8.515,7.5,11v12.5h9V11z",
  stroke: "#ffffff",
  fill: "none",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.b7c5bfe0.svg";
export { ForwardRef as ReactComponent };